import React, { Component } from 'react';

import BeWise_Header from './header';
import BeWise_Footer from './footer';
import BeWise_CourseSideBar from './coursesideBar';

import { Helmet } from 'react-helmet';

class CourseLayout extends Component {

    constructor(props) {
        super(props);
        this.state = {
			auth_data: JSON.parse(localStorage.getItem("user_data"))
        };
    }

    render() {

	return ( 
		<div className="App container-scroller bewiseui">
		 
		<BeWise_Header/>
		<div class="container-fluid page-body-wrapper">
		<BeWise_CourseSideBar/>
		<div class="main-panel">
			<div class="content-wrapper nopadding overflowx">
				{this.props.children}
			</div>
			<BeWise_Footer/>
		</div>
		</div>
		</div>

	)

	}

}



export default CourseLayout;


// WEBPACK FOOTER //
// ./src/components/bewise/courselayout.jsx